import { Box } from "@mui/material";
import Dialog from "@mui/material/Dialog";

function CustomDialog({ children, sx = [], ...props }) {
  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={"xs"}
      container={document.getElementById("AppContainer")}
      sx={[
        {
          position: "absolute",
          minHeight: 180,
          "& .MuiBackdrop-root": { position: "absolute" },
          "& .MuiPaper-root": {
            p: "16px",
            borderRadius: "12px",
            minHeight: 180,
            // display: "flex",
            // flexDirection: "column",
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      {children}
    </Dialog>
  );
}

export default CustomDialog;
